import { REACT_APP_GTM_TOGGLE, REACT_APP_GTM_ID } from "../../config";

const GTM_ENABLED = REACT_APP_GTM_TOGGLE && !!REACT_APP_GTM_ID;

const executeIfEnabled = (fn) => {
  return (...args) => {
    if (GTM_ENABLED) {
      return fn(...args);
    }
  };
};

export const initGoogleTagManager = executeIfEnabled(() => {
  const gtmId = REACT_APP_GTM_ID;

  if (!gtmId) {
    console.warn("GTM ID not found in environment variables");
    return;
  }

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    const dl = l !== "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", gtmId);
});

export const pushToDataLayer = executeIfEnabled((data) => {
  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
});

export const trackEvent = executeIfEnabled((eventName, eventData = {}) => {
  pushToDataLayer({
    event: eventName,
    ...eventData,
  });
});

export const trackPickupScheduled = executeIfEnabled(() => {
  trackEvent("pickup_scheduled", {
    event_category: "Pickup",
    event_action: "scheduled",
  });
});

export const trackCustomEvent = executeIfEnabled((category, action, label = null, value = null) => {
  const eventData = {
    event_category: category,
    event_action: action,
  };

  if (label) eventData.event_label = label;
  if (value !== null) eventData.value = value;

  trackEvent("custom_event", eventData);
});

export const trackPageView = executeIfEnabled((pagePath, pageTitle) => {
  pushToDataLayer({
    event: "page_view",
    page_path: pagePath || window.location.pathname,
    page_title: pageTitle || document.title,
  });
});
